import { render, staticRenderFns } from "./EdiFulfillment.vue?vue&type=template&id=9f6bd610&"
import script from "./EdiFulfillment.vue?vue&type=script&lang=js&"
export * from "./EdiFulfillment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports